<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="email">
        <el-input v-model="queryParams.email" filterable placeholder="邮箱" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="orderNum">
        <el-input v-model="queryParams.orderNum" placeholder="订单号" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="dateRange">
        <el-date-picker
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="dateRange"
                @change="search"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!--搜索-->
    <!--列表-->
    <el-table :data="tableData" ref="tableData" border v-loading="loading" @sort-change="tableSortChange">
      <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="orderNum" label="订单号" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="email" label="邮箱" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="emailSubject" label="邮件主题" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="emailContent" label="邮件内容" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="status" label="发送状态" align="center" min-width="80">
          <template slot-scope="{row}">
              <el-tag v-if="row.status == '0'">未发送</el-tag>
              <el-tag type="success" v-if="row.status == '1'">已发送</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="rmk" label="备注" align="center" min-width="140" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="发送时间" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.updateTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <!--操作-->
      <el-table-column label="操作" min-width="80" align="center" fixed="right">
        <!-- <template slot-scope="scope">
          <el-button type="text" icon="el-icon-view" @click="detailInfo(scope.row)">详情</el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
            v-show="total>0"
            :total="total"
            :page.sync="page"
            :limit.sync="pageSize"
            @pagination="initData"
    />
  </div>
</template>

<script>
  import { esimMailRecordList } from "@/api/api.js";

  export default {
    name: 'esimMailRecord',
    data () {
      return {
        loading: false,
        dateRange: [],
        queryParams: {
          iccid: undefined,
          email: undefined,
          orderNum: undefined
        },
        tableData: [{
          id: undefined,
          iccid: undefined,
          email: undefined,
          orderNum: undefined,
          downloadUrl: undefined,
          emailSubject: undefined,
          emailContent: undefined,
          createTime: undefined,
          status: undefined,
          rmk: undefined
        }],
        searchTime: [],
        page: 1,
        pageSize: 20,
        total: 0,
        agentOptions: [],
        // 排序方式
        sortOrder: "",
        // 排序名称
        sortName: "",
      }
    },
    computed: {
      adminShow () {
        return this.$store.getters.user.userType == "1";
      }
    },
    methods: {
      // 搜索
      search () {
        this.tableData = [];
        this.page = 1;
        this.initData();
      },
      // 重置
      resetQuery () {
        this.dateRange = [];
        this.resetForm("queryForm");
        this.search();
      },
      // 排序
      tableSortChange (val) {
        this.sortOrder = val.order == "descending" ? "desc" : "asc";
        this.sortName = val.prop == "createTime" ? "createTime" : "updateTime";
        this.initData();
      },
      // 获取列表的数据
      initData () {
        let params = {
          model: {
            ... this.addDateRange(this.queryParams, this.dateRange),
            order: this.sortOrder,
            sort: this.sortName,
          },
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.tableData = [];
        esimMailRecordList(params).then(res => {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.tableData.map((item, index) => {
            item.ids = index + 1
          })
          this.total = res.data.data.total;
        })
      }
    },
    mounted () {
      this.initData();
    },
    created () {},
    watch: {
        '$route': {
            handler: function (to, from) {
                if (to.name == "esimMailRecord") {
                    this.initData();
                }
            },
            // 深度观察监听
            deep: true,
        },
    },
  };
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}

</style>
